import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AccordionCardFlatComponent } from './accordion-card-flat/accordion-card-flat.component';
import { AccordionCardComponent } from './accordion-card/accordion-card.component';
import { AccordionPanelComponent } from './accordion-panel/accordion-panel.component';
import { AddressComponent } from './components/address/address.component';
import { Call4UPopupComponent } from './components/call4u/popup.component';
import { UpdateBillingInfosPopupComponent } from './components/billing-infos/popup.component';
import { TwoFactorNoticeComponent } from './components/two-factor-notice/two-factor-notice.component';
import { ACPopupComponent } from './components/active-campaign/popup.component';
import { ConfigurationConfirmModalComponent } from './components/configuration-confirm-modal/configuration-confirm-modal.component';
import { ConfigurationHistoryModalComponent } from './components/configuration-history-modal/configuration-history-modal.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { FileComponent } from './components/file/file.component';
import { HiddenFieldComponent } from './components/hidden-field/hidden-field.component';
import { LoadingButtonComponent } from './components/loading-button/loading-button.component';
import { PartialSendConfirmModalComponent } from './components/partial-send-confirm-modal/partial-send-confirm-modal.component';
import { PlanMessageComponent } from './components/plan-message/plan-message.component';
import { PromptActionsComponent } from './components/prompt-actions/prompt-actions.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { ToastComponent } from './components/toast/toast.component';
import { VerificationMessageComponent } from './components/verification-message/verification-message.component';
import { VerificationMessageWhatsappComponent } from './components/verification-message-whatsapp/verification-message-whatsapp.component';
import { AccountVersionThemeDirective } from './directives/account-version-theme.directive';
import { CepDirective } from './directives/cep.directive';
import { CpfDirective } from './directives/cpf.directive';
import { CreditCardDirective } from './directives/credit-card.directive';
import { PhoneDirective } from './directives/phone.directive';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { UserInterceptor } from './interceptors/user.interceptor';
import { PaginationComponent } from './pagination/pagination.component';
import { BooleanStringPipe } from './pipes/boolean-string.pipe';
import { BroadcastStatusPipe } from './pipes/BroadcastStatus.pipe';
import { IntervalTypePipe } from './pipes/interval-type.pipe';
import { MoneyMicrosPipe } from './pipes/money-micros.pipe';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';
import { PeriodPipe } from './pipes/period.pipe';
import { PrettyJsonPipe } from './pipes/pretty-json.pipe';
import { ProfilePipe } from './pipes/profile.pipe';
import { UserFieldLabelPipe } from './pipes/user-field-label.pipe';
import { UserEditLogsComponent } from './components/user-edit-logs/user-edit-logs.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { SwitcherComponent } from './switcher/switcher.component';
import { AnalyticsCardComponent } from './analytics/card/card.component';
import { TestEventModalComponent } from './components/test-event-modal/test-event-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SearchSelectComponent } from './components/search-select/search-select.component';
import { WindowDatetimePickerComponent } from './components/window-datetime-picker/window-datetime-picker.component';
import { BrDatetimeInputComponent } from './components/br-datetime-input/br-datetime-input.component';
import { SendWhenComponent } from './components/send-when/send-when.component';

@NgModule({
  declarations: [
    PaginationComponent,
    LoadingButtonComponent,
    SkeletonComponent,
    ToastComponent,
    ConfigurationConfirmModalComponent,
    ConfigurationHistoryModalComponent,
    ConfirmationModalComponent,
    PartialSendConfirmModalComponent,
    HiddenFieldComponent,
    SwitcherComponent,
    AccordionCardComponent,
    AccordionPanelComponent,
    AccordionCardFlatComponent,
    RadioButtonComponent,
    PhoneDirective,
    CpfDirective,
    CreditCardDirective,
    CepDirective,
    AccountVersionThemeDirective,
    PlanMessageComponent,
    VerificationMessageComponent,
    VerificationMessageWhatsappComponent,
    FileComponent,
    PrettyJsonPipe,
    BooleanStringPipe,
    IntervalTypePipe,
    MoneyMicrosPipe,
    PaymentStatusPipe,
    ProfilePipe,
    UserFieldLabelPipe,
    UserEditLogsComponent,
    AddressComponent,
    PeriodPipe,
    BroadcastStatusPipe,
    Call4UPopupComponent,
    ACPopupComponent,
    UpdateBillingInfosPopupComponent,
    TwoFactorNoticeComponent,
    AnalyticsCardComponent,
    TestEventModalComponent,
    PromptActionsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    DragDropModule,
    RouterModule,
    SearchSelectComponent,
    WindowDatetimePickerComponent,
    BrDatetimeInputComponent,
    SendWhenComponent,
  ],
  exports: [
    AccordionCardComponent,
    AccordionPanelComponent,
    AccordionCardFlatComponent,
    AddressComponent,
    ConfigurationConfirmModalComponent,
    ConfigurationHistoryModalComponent,
    ConfirmationModalComponent,
    HiddenFieldComponent,
    LoadingButtonComponent,
    SkeletonComponent,
    PaginationComponent,
    RadioButtonComponent,
    SwitcherComponent,
    ToastComponent,
    PhoneDirective,
    CpfDirective,
    CreditCardDirective,
    CepDirective,
    AccountVersionThemeDirective,
    PlanMessageComponent,
    FileComponent,
    PrettyJsonPipe,
    BooleanStringPipe,
    IntervalTypePipe,
    MoneyMicrosPipe,
    PaymentStatusPipe,
    ProfilePipe,
    UserFieldLabelPipe,
    UserEditLogsComponent,
    PeriodPipe,
    BroadcastStatusPipe,
    VerificationMessageComponent,
    VerificationMessageWhatsappComponent,
    Call4UPopupComponent,
    ACPopupComponent,
    UpdateBillingInfosPopupComponent,
    TwoFactorNoticeComponent,
    AnalyticsCardComponent,
    TestEventModalComponent,
    PromptActionsComponent,
    SearchSelectComponent,
    WindowDatetimePickerComponent,
    BrDatetimeInputComponent,
    SendWhenComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    ProfilePipe
  ]
})
export class SharedModule { }
